import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { GET_OR_CREATE_BILL_SUCCESS, getOrCreateBill } from "../../../../store/actions/loan-actions";
import { ModalPaymentContainer } from "./modal-payment-container";
import { CopyHelper } from '../../../../utils/helper/copy-helper';
import { CheckIcon, PixLogoIcon, SpinnerIcon } from "../icons";


function ModalPixOptions(props) {
  const { show, onClose, installment, loanId, device, getOrCreateBill, onModalAlertChange } = props;
  const pixCode = installment?.bill?.execution?.additionalInformation?.pixPaymentCode;
  const billId = installment?.bill?.id;
  const installmentNumber = installment?.number;
  const [actualPixCode, setActualPixCode] = useState(pixCode);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [actualBillId, setActualBillId] = useState(billId);
  const [actualPixQRCode, setActualPixQRCode] = useState(null);
  const [copied, setCopied] = useState(false);


  const getBill = async () => {
    setLoading(true);
    if (!actualPixCode) {
      const response = await getOrCreateBill('PIX', device, actualBillId, [installmentNumber]);

      if (response.type === GET_OR_CREATE_BILL_SUCCESS) {
        const bill = response.payload;
        const pixCode = bill?.execution?.additionalInformation?.pixPaymentCode;
        const qrCode = bill?.execution?.additionalInformation?.pixQRCode;
        setActualBillId(bill?.id);
        setActualPixCode(pixCode);
        setActualPixQRCode(qrCode);
      }
    }
    setLoading(false);
  };

  const getBillCallback = useCallback(getBill, [actualPixCode, actualBillId, device, installmentNumber, getOrCreateBill]);

  useEffect(() => {
    if (show) {
      (async () => {
        await getBillCallback();
      })();
    }
    return () => {
    };
  }, [show, getBillCallback]);

  const copyPixCode = async () => {
    setLoadingButton(true);
    setCopied(false);
    CopyHelper.copyToClipboard(actualPixCode);
    onModalAlertChange(true, `Boleto enviado para ${hideEmailPartially(loan.application.personal.emailAddress)}.`, "Sucesso!");
    setLoadingButton(false);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {show &&
        <ModalPaymentContainer
          headerTitle="Pagar com Pix"
          icon={<PixLogoIcon />}
          onClose={onClose}
          loadingButton={loadingButton}
          buttonText={
            copied ? <CheckIcon style={{ color: '#ffffff', width: '30px', height: '30px' }} className="" />
              : <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: '16px',
              }}>
                <FontAwesomeIcon icon={faCopy} size="lg" />
                <span style={{ fontSize: '20px' }}>Copiar link</span>
              </div>
          }
          onButtonClick={actualPixCode ? copyPixCode : null}
          headerContent={
            <>
              <p className="modal-payment-card-content-header-company-name">SuperSim Análise de Dados e Correspondente Bancário Ltda</p>
              <p className="modal-payment-card-content-header-company-id">33.030.944/0001-**</p>
            </>
          }
        >
          <div className="modal-pix-options">
            {actualPixCode
              ? <>
                <p className="modal-pix-options-text">Copie o link abaixo para realizar o <strong>pagamento no aplicativo do seu banco:</strong></p>
                {actualPixQRCode &&
                  <div className="modal-pix-options-qr-code">
                    <img id="modal-pix-options-qr-code-image" src={`data:image/png;base64,${actualPixQRCode}`} alt="Pix código QR" />
                  </div>}
                <div className="modal-pix-options-card">
                  <div className="modal-pix-options-card-text">
                    {actualPixCode}
                  </div>
                </div>
              </>
              : loading
                ? <div className="modal-pix-options-loading">
                  <SpinnerIcon className="loading" />
                </div>
                : <>
                  <div className="modal-pix-options-refresh-button">
                    <button type="button" onClick={getBill}>
                      <FontAwesomeIcon icon={faRedo} style={{ width: '100%', height: '100%' }} />
                    </button>
                  </div>
                  <div className="modal-pix-options-refresh-text">O código PIX pode demorar alguns segundos para ser gerado. Clique em atualizar para verificar se o código já está pronto.</div>
                </>
            }
          </div>
        </ModalPaymentContainer>
      }
    </>
  );
}

ModalPixOptions.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  installment: PropTypes.object.isRequired,
  loanId: PropTypes.number.isRequired,
};

ModalPixOptions.defaultProps = {
  show: false,
};

const mapStateToProps = (state) => ({
  device: state.customer.device,
});

const mapDispatchToProps = (dispatch) => ({
  getOrCreateBill: (billingMethod, device, billId, installmentsNumbers) => dispatch(getOrCreateBill(billingMethod, device, billId, installmentsNumbers)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalPixOptions);
